var map = {
	"./prism-abap.js": 90318,
	"./prism-abap.min.js": 30720,
	"./prism-abnf.js": 50151,
	"./prism-abnf.min.js": 99465,
	"./prism-actionscript.js": 72513,
	"./prism-actionscript.min.js": 48835,
	"./prism-ada.js": 40862,
	"./prism-ada.min.js": 42512,
	"./prism-agda.js": 77099,
	"./prism-agda.min.js": 28805,
	"./prism-al.js": 27849,
	"./prism-al.min.js": 93707,
	"./prism-antlr4.js": 71313,
	"./prism-antlr4.min.js": 51731,
	"./prism-apacheconf.js": 84716,
	"./prism-apacheconf.min.js": 56062,
	"./prism-apex.js": 67476,
	"./prism-apex.min.js": 76422,
	"./prism-apl.js": 76181,
	"./prism-apl.min.js": 85439,
	"./prism-applescript.js": 17185,
	"./prism-applescript.min.js": 54019,
	"./prism-aql.js": 36184,
	"./prism-aql.min.js": 37010,
	"./prism-arduino.js": 15026,
	"./prism-arduino.min.js": 80844,
	"./prism-arff.js": 53487,
	"./prism-arff.min.js": 5137,
	"./prism-armasm.js": 18937,
	"./prism-armasm.min.js": 16155,
	"./prism-arturo.js": 28239,
	"./prism-arturo.min.js": 71377,
	"./prism-asciidoc.js": 46371,
	"./prism-asciidoc.min.js": 4381,
	"./prism-asm6502.js": 62694,
	"./prism-asm6502.min.js": 45592,
	"./prism-asmatmel.js": 13784,
	"./prism-asmatmel.min.js": 71922,
	"./prism-aspnet.js": 30559,
	"./prism-aspnet.min.js": 53409,
	"./prism-autohotkey.js": 10845,
	"./prism-autohotkey.min.js": 80807,
	"./prism-autoit.js": 9118,
	"./prism-autoit.min.js": 81872,
	"./prism-avisynth.js": 17224,
	"./prism-avisynth.min.js": 28834,
	"./prism-avro-idl.js": 25442,
	"./prism-avro-idl.min.js": 6748,
	"./prism-awk.js": 45167,
	"./prism-awk.min.js": 6417,
	"./prism-bash.js": 57022,
	"./prism-bash.min.js": 53552,
	"./prism-basic.js": 87336,
	"./prism-basic.min.js": 92546,
	"./prism-batch.js": 40990,
	"./prism-batch.min.js": 32848,
	"./prism-bbcode.js": 42493,
	"./prism-bbcode.min.js": 24007,
	"./prism-bbj.js": 35328,
	"./prism-bbj.min.js": 13370,
	"./prism-bicep.js": 65869,
	"./prism-bicep.min.js": 72343,
	"./prism-birb.js": 86061,
	"./prism-birb.min.js": 2231,
	"./prism-bison.js": 99669,
	"./prism-bison.min.js": 10239,
	"./prism-bnf.js": 22248,
	"./prism-bnf.min.js": 83202,
	"./prism-bqn.js": 45663,
	"./prism-bqn.min.js": 94017,
	"./prism-brainfuck.js": 29905,
	"./prism-brainfuck.min.js": 64403,
	"./prism-brightscript.js": 78575,
	"./prism-brightscript.min.js": 50929,
	"./prism-bro.js": 19011,
	"./prism-bro.min.js": 92669,
	"./prism-bsl.js": 79827,
	"./prism-bsl.min.js": 31757,
	"./prism-c.js": 50271,
	"./prism-c.min.js": 81793,
	"./prism-cfscript.js": 68762,
	"./prism-cfscript.min.js": 17716,
	"./prism-chaiscript.js": 65910,
	"./prism-chaiscript.min.js": 22184,
	"./prism-cil.js": 89262,
	"./prism-cil.min.js": 6784,
	"./prism-cilkc.js": 97512,
	"./prism-cilkc.min.js": 58242,
	"./prism-cilkcpp.js": 60000,
	"./prism-cilkcpp.min.js": 91610,
	"./prism-clike.js": 75624,
	"./prism-clike.min.js": 54146,
	"./prism-clojure.js": 70478,
	"./prism-clojure.min.js": 63584,
	"./prism-cmake.js": 72509,
	"./prism-cmake.min.js": 38855,
	"./prism-cobol.js": 80065,
	"./prism-cobol.min.js": 38755,
	"./prism-coffeescript.js": 44511,
	"./prism-coffeescript.min.js": 68097,
	"./prism-concurnas.js": 16574,
	"./prism-concurnas.min.js": 53392,
	"./prism-cooklang.js": 36340,
	"./prism-cooklang.min.js": 49350,
	"./prism-coq.js": 87123,
	"./prism-coq.min.js": 67245,
	"./prism-core.js": 71983,
	"./prism-core.min.js": 35345,
	"./prism-cpp.js": 72415,
	"./prism-cpp.min.js": 95457,
	"./prism-crystal.js": 11380,
	"./prism-crystal.min.js": 58182,
	"./prism-csharp.js": 5651,
	"./prism-csharp.min.js": 68141,
	"./prism-cshtml.js": 30019,
	"./prism-cshtml.min.js": 30077,
	"./prism-csp.js": 58160,
	"./prism-csp.min.js": 25258,
	"./prism-css-extras.js": 25365,
	"./prism-css-extras.min.js": 20799,
	"./prism-css.js": 91113,
	"./prism-css.min.js": 70827,
	"./prism-csv.js": 62630,
	"./prism-csv.min.js": 33560,
	"./prism-cue.js": 57193,
	"./prism-cue.min.js": 67531,
	"./prism-cypher.js": 53575,
	"./prism-cypher.min.js": 76425,
	"./prism-d.js": 27966,
	"./prism-d.min.js": 37808,
	"./prism-dart.js": 60869,
	"./prism-dart.min.js": 47151,
	"./prism-dataweave.js": 5372,
	"./prism-dataweave.min.js": 79790,
	"./prism-dax.js": 40555,
	"./prism-dax.min.js": 19685,
	"./prism-dhall.js": 45293,
	"./prism-dhall.min.js": 65047,
	"./prism-diff.js": 47839,
	"./prism-diff.min.js": 98753,
	"./prism-django.js": 62091,
	"./prism-django.min.js": 62021,
	"./prism-dns-zone-file.js": 21451,
	"./prism-dns-zone-file.min.js": 23941,
	"./prism-docker.js": 70568,
	"./prism-docker.min.js": 24002,
	"./prism-dot.js": 84497,
	"./prism-dot.min.js": 71283,
	"./prism-ebnf.js": 763,
	"./prism-ebnf.min.js": 3285,
	"./prism-editorconfig.js": 33959,
	"./prism-editorconfig.min.js": 79465,
	"./prism-eiffel.js": 39319,
	"./prism-eiffel.min.js": 15353,
	"./prism-ejs.js": 56258,
	"./prism-ejs.min.js": 74460,
	"./prism-elixir.js": 84051,
	"./prism-elixir.min.js": 4077,
	"./prism-elm.js": 76110,
	"./prism-elm.min.js": 46912,
	"./prism-erb.js": 57449,
	"./prism-erb.min.js": 34507,
	"./prism-erlang.js": 37099,
	"./prism-erlang.min.js": 98277,
	"./prism-etlua.js": 97595,
	"./prism-etlua.min.js": 32757,
	"./prism-excel-formula.js": 80130,
	"./prism-excel-formula.min.js": 37148,
	"./prism-factor.js": 61507,
	"./prism-factor.min.js": 33533,
	"./prism-false.js": 45629,
	"./prism-false.min.js": 33479,
	"./prism-firestore-security-rules.js": 59576,
	"./prism-firestore-security-rules.min.js": 24466,
	"./prism-flow.js": 13028,
	"./prism-flow.min.js": 10998,
	"./prism-fortran.js": 32048,
	"./prism-fortran.min.js": 65610,
	"./prism-fsharp.js": 47782,
	"./prism-fsharp.min.js": 85944,
	"./prism-ftl.js": 27308,
	"./prism-ftl.min.js": 31998,
	"./prism-gap.js": 76862,
	"./prism-gap.min.js": 29072,
	"./prism-gcode.js": 50530,
	"./prism-gcode.min.js": 70684,
	"./prism-gdscript.js": 59616,
	"./prism-gdscript.min.js": 12634,
	"./prism-gedcom.js": 6497,
	"./prism-gedcom.min.js": 36547,
	"./prism-gettext.js": 11441,
	"./prism-gettext.min.js": 60147,
	"./prism-gherkin.js": 12420,
	"./prism-gherkin.min.js": 45910,
	"./prism-git.js": 85818,
	"./prism-git.min.js": 20148,
	"./prism-glsl.js": 73980,
	"./prism-glsl.min.js": 78766,
	"./prism-gml.js": 36774,
	"./prism-gml.min.js": 3032,
	"./prism-gn.js": 56633,
	"./prism-gn.min.js": 1147,
	"./prism-go-module.js": 75955,
	"./prism-go-module.min.js": 25965,
	"./prism-go.js": 86378,
	"./prism-go.min.js": 89348,
	"./prism-gradle.js": 43523,
	"./prism-gradle.min.js": 94525,
	"./prism-graphql.js": 34619,
	"./prism-graphql.min.js": 52949,
	"./prism-groovy.js": 75538,
	"./prism-groovy.min.js": 31276,
	"./prism-haml.js": 40418,
	"./prism-haml.min.js": 87548,
	"./prism-handlebars.js": 43800,
	"./prism-handlebars.min.js": 15282,
	"./prism-haskell.js": 554,
	"./prism-haskell.min.js": 74660,
	"./prism-haxe.js": 3700,
	"./prism-haxe.min.js": 55046,
	"./prism-hcl.js": 55025,
	"./prism-hcl.min.js": 50163,
	"./prism-hlsl.js": 14023,
	"./prism-hlsl.min.js": 60681,
	"./prism-hoon.js": 47224,
	"./prism-hoon.min.js": 91282,
	"./prism-hpkp.js": 75839,
	"./prism-hpkp.min.js": 19329,
	"./prism-hsts.js": 79788,
	"./prism-hsts.min.js": 79774,
	"./prism-http.js": 24784,
	"./prism-http.min.js": 28714,
	"./prism-ichigojam.js": 86597,
	"./prism-ichigojam.min.js": 37039,
	"./prism-icon.js": 90237,
	"./prism-icon.min.js": 33159,
	"./prism-icu-message-format.js": 14487,
	"./prism-icu-message-format.min.js": 55033,
	"./prism-idris.js": 37723,
	"./prism-idris.min.js": 76565,
	"./prism-iecst.js": 36794,
	"./prism-iecst.min.js": 48916,
	"./prism-ignore.js": 8714,
	"./prism-ignore.min.js": 91844,
	"./prism-inform7.js": 48880,
	"./prism-inform7.min.js": 17290,
	"./prism-ini.js": 70824,
	"./prism-ini.min.js": 74786,
	"./prism-io.js": 17064,
	"./prism-io.min.js": 78274,
	"./prism-j.js": 54688,
	"./prism-j.min.js": 62234,
	"./prism-java.js": 96976,
	"./prism-java.min.js": 86333,
	"./prism-javadoc.js": 36852,
	"./prism-javadoc.min.js": 19942,
	"./prism-javadoclike.js": 35643,
	"./prism-javadoclike.min.js": 94261,
	"./prism-javascript.js": 25723,
	"./prism-javascript.min.js": 12661,
	"./prism-javastacktrace.js": 87881,
	"./prism-javastacktrace.min.js": 4395,
	"./prism-jexl.js": 4993,
	"./prism-jexl.min.js": 89571,
	"./prism-jolie.js": 3717,
	"./prism-jolie.min.js": 87983,
	"./prism-jq.js": 42177,
	"./prism-jq.min.js": 28867,
	"./prism-js-extras.js": 9799,
	"./prism-js-extras.min.js": 76841,
	"./prism-js-templates.js": 54029,
	"./prism-js-templates.min.js": 10423,
	"./prism-jsdoc.js": 16625,
	"./prism-jsdoc.min.js": 72544,
	"./prism-json.js": 72514,
	"./prism-json.min.js": 13564,
	"./prism-json5.js": 10267,
	"./prism-json5.min.js": 78837,
	"./prism-jsonp.js": 70696,
	"./prism-jsonp.min.js": 44226,
	"./prism-jsstacktrace.js": 52850,
	"./prism-jsstacktrace.min.js": 4396,
	"./prism-jsx.js": 65903,
	"./prism-jsx.min.js": 85841,
	"./prism-julia.js": 60463,
	"./prism-julia.min.js": 19281,
	"./prism-keepalived.js": 54054,
	"./prism-keepalived.min.js": 44472,
	"./prism-keyman.js": 54033,
	"./prism-keyman.min.js": 35763,
	"./prism-kotlin.js": 69913,
	"./prism-kotlin.min.js": 42459,
	"./prism-kumir.js": 62486,
	"./prism-kumir.min.js": 36264,
	"./prism-kusto.js": 59102,
	"./prism-kusto.min.js": 93968,
	"./prism-latex.js": 25294,
	"./prism-latex.min.js": 99008,
	"./prism-latte.js": 84403,
	"./prism-latte.min.js": 50266,
	"./prism-less.js": 18713,
	"./prism-less.min.js": 83643,
	"./prism-lilypond.js": 74215,
	"./prism-lilypond.min.js": 70761,
	"./prism-linker-script.js": 95635,
	"./prism-linker-script.min.js": 57965,
	"./prism-liquid.js": 57936,
	"./prism-liquid.min.js": 98954,
	"./prism-lisp.js": 10116,
	"./prism-lisp.min.js": 77174,
	"./prism-livescript.js": 86545,
	"./prism-livescript.min.js": 55667,
	"./prism-llvm.js": 3801,
	"./prism-llvm.min.js": 45179,
	"./prism-log.js": 78160,
	"./prism-log.min.js": 70346,
	"./prism-lolcode.js": 75224,
	"./prism-lolcode.min.js": 93938,
	"./prism-lua.js": 80064,
	"./prism-lua.min.js": 36890,
	"./prism-magma.js": 66867,
	"./prism-magma.min.js": 80749,
	"./prism-makefile.js": 30260,
	"./prism-makefile.min.js": 4006,
	"./prism-markdown.js": 75545,
	"./prism-markdown.min.js": 13467,
	"./prism-markup-templating.js": 19700,
	"./prism-markup-templating.min.js": 6726,
	"./prism-markup.js": 64312,
	"./prism-markup.min.js": 4818,
	"./prism-mata.js": 645,
	"./prism-mata.min.js": 65807,
	"./prism-matlab.js": 65961,
	"./prism-matlab.min.js": 8747,
	"./prism-maxscript.js": 32851,
	"./prism-maxscript.min.js": 19053,
	"./prism-mel.js": 60416,
	"./prism-mel.min.js": 58490,
	"./prism-mermaid.js": 4201,
	"./prism-mermaid.min.js": 4651,
	"./prism-metafont.js": 52220,
	"./prism-metafont.min.js": 29518,
	"./prism-mizar.js": 77185,
	"./prism-mizar.min.js": 12515,
	"./prism-mongodb.js": 86380,
	"./prism-mongodb.min.js": 48606,
	"./prism-monkey.js": 11621,
	"./prism-monkey.min.js": 97327,
	"./prism-moonscript.js": 71386,
	"./prism-moonscript.min.js": 55668,
	"./prism-n1ql.js": 79988,
	"./prism-n1ql.min.js": 55974,
	"./prism-n4js.js": 66449,
	"./prism-n4js.min.js": 3347,
	"./prism-nand2tetris-hdl.js": 9121,
	"./prism-nand2tetris-hdl.min.js": 93443,
	"./prism-naniscript.js": 48607,
	"./prism-naniscript.min.js": 66401,
	"./prism-nasm.js": 55877,
	"./prism-nasm.min.js": 39279,
	"./prism-neon.js": 5796,
	"./prism-neon.min.js": 92982,
	"./prism-nevod.js": 28904,
	"./prism-nevod.min.js": 80770,
	"./prism-nginx.js": 99486,
	"./prism-nginx.min.js": 97712,
	"./prism-nim.js": 37110,
	"./prism-nim.min.js": 91816,
	"./prism-nix.js": 35177,
	"./prism-nix.min.js": 38955,
	"./prism-nsis.js": 57787,
	"./prism-nsis.min.js": 14773,
	"./prism-objectivec.js": 20596,
	"./prism-objectivec.min.js": 91014,
	"./prism-ocaml.js": 39814,
	"./prism-ocaml.min.js": 99896,
	"./prism-odin.js": 52748,
	"./prism-odin.min.js": 97822,
	"./prism-opencl.js": 58415,
	"./prism-opencl.min.js": 65681,
	"./prism-openqasm.js": 88530,
	"./prism-openqasm.min.js": 92460,
	"./prism-oz.js": 13885,
	"./prism-oz.min.js": 13063,
	"./prism-parigp.js": 94741,
	"./prism-parigp.min.js": 64927,
	"./prism-parser.js": 27059,
	"./prism-parser.min.js": 31117,
	"./prism-pascal.js": 97376,
	"./prism-pascal.min.js": 69914,
	"./prism-pascaligo.js": 9427,
	"./prism-pascaligo.min.js": 40493,
	"./prism-pcaxis.js": 70736,
	"./prism-pcaxis.min.js": 71690,
	"./prism-peoplecode.js": 91166,
	"./prism-peoplecode.min.js": 81808,
	"./prism-perl.js": 32821,
	"./prism-perl.min.js": 25247,
	"./prism-php-extras.js": 55248,
	"./prism-php-extras.min.js": 45610,
	"./prism-php.js": 43554,
	"./prism-php.min.js": 63484,
	"./prism-phpdoc.js": 7506,
	"./prism-phpdoc.min.js": 57868,
	"./prism-plant-uml.js": 32580,
	"./prism-plant-uml.min.js": 82070,
	"./prism-plsql.js": 85106,
	"./prism-plsql.min.js": 67852,
	"./prism-powerquery.js": 97551,
	"./prism-powerquery.min.js": 69393,
	"./prism-powershell.js": 30905,
	"./prism-powershell.min.js": 48955,
	"./prism-processing.js": 14775,
	"./prism-processing.min.js": 58425,
	"./prism-prolog.js": 16167,
	"./prism-prolog.min.js": 33609,
	"./prism-promql.js": 24127,
	"./prism-promql.min.js": 57185,
	"./prism-properties.js": 41781,
	"./prism-properties.min.js": 67839,
	"./prism-protobuf.js": 39535,
	"./prism-protobuf.min.js": 91633,
	"./prism-psl.js": 54121,
	"./prism-psl.min.js": 69387,
	"./prism-pug.js": 28882,
	"./prism-pug.min.js": 9196,
	"./prism-puppet.js": 48214,
	"./prism-puppet.min.js": 67176,
	"./prism-pure.js": 86318,
	"./prism-pure.min.js": 91136,
	"./prism-purebasic.js": 32782,
	"./prism-purebasic.min.js": 1536,
	"./prism-purescript.js": 29405,
	"./prism-purescript.min.js": 2695,
	"./prism-python.js": 52342,
	"./prism-python.min.js": 26792,
	"./prism-q.js": 84113,
	"./prism-q.min.js": 65939,
	"./prism-qml.js": 93732,
	"./prism-qml.min.js": 36118,
	"./prism-qore.js": 84709,
	"./prism-qore.min.js": 16303,
	"./prism-qsharp.js": 41329,
	"./prism-qsharp.min.js": 6707,
	"./prism-r.js": 27768,
	"./prism-r.min.js": 87826,
	"./prism-racket.js": 47702,
	"./prism-racket.min.js": 20264,
	"./prism-reason.js": 1396,
	"./prism-reason.min.js": 32838,
	"./prism-regex.js": 75133,
	"./prism-regex.min.js": 68871,
	"./prism-rego.js": 38383,
	"./prism-rego.min.js": 10321,
	"./prism-renpy.js": 60636,
	"./prism-renpy.min.js": 7278,
	"./prism-rescript.js": 19514,
	"./prism-rescript.min.js": 6900,
	"./prism-rest.js": 71806,
	"./prism-rest.min.js": 48112,
	"./prism-rip.js": 89309,
	"./prism-rip.min.js": 97031,
	"./prism-roboconf.js": 45714,
	"./prism-roboconf.min.js": 12236,
	"./prism-robotframework.js": 39860,
	"./prism-robotframework.min.js": 13926,
	"./prism-ruby.js": 41648,
	"./prism-ruby.min.js": 96010,
	"./prism-rust.js": 75342,
	"./prism-rust.min.js": 78624,
	"./prism-sas.js": 93391,
	"./prism-sas.min.js": 52401,
	"./prism-sass.js": 99562,
	"./prism-sass.min.js": 9060,
	"./prism-scala.js": 64252,
	"./prism-scala.min.js": 45358,
	"./prism-scheme.js": 14183,
	"./prism-scheme.min.js": 22601,
	"./prism-scss.js": 94604,
	"./prism-scss.min.js": 96414,
	"./prism-shell-session.js": 60061,
	"./prism-shell-session.min.js": 63559,
	"./prism-smali.js": 3842,
	"./prism-smali.min.js": 82684,
	"./prism-smalltalk.js": 18619,
	"./prism-smalltalk.min.js": 17941,
	"./prism-smarty.js": 99124,
	"./prism-smarty.min.js": 92902,
	"./prism-sml.js": 23466,
	"./prism-sml.min.js": 96772,
	"./prism-solidity.js": 43537,
	"./prism-solidity.min.js": 85171,
	"./prism-solution-file.js": 24686,
	"./prism-solution-file.min.js": 94560,
	"./prism-soy.js": 18731,
	"./prism-soy.min.js": 94021,
	"./prism-sparql.js": 70537,
	"./prism-sparql.min.js": 80939,
	"./prism-splunk-spl.js": 80371,
	"./prism-splunk-spl.min.js": 9325,
	"./prism-sqf.js": 85540,
	"./prism-sqf.min.js": 47926,
	"./prism-sql.js": 96966,
	"./prism-sql.min.js": 39864,
	"./prism-squirrel.js": 88191,
	"./prism-squirrel.min.js": 93569,
	"./prism-stan.js": 79032,
	"./prism-stan.min.js": 12626,
	"./prism-stata.js": 76263,
	"./prism-stata.min.js": 1129,
	"./prism-stylus.js": 77382,
	"./prism-stylus.min.js": 27064,
	"./prism-supercollider.js": 95009,
	"./prism-supercollider.min.js": 44579,
	"./prism-swift.js": 54793,
	"./prism-swift.min.js": 23243,
	"./prism-systemd.js": 42237,
	"./prism-systemd.min.js": 46791,
	"./prism-t4-cs.js": 23119,
	"./prism-t4-cs.min.js": 73521,
	"./prism-t4-templating.js": 99948,
	"./prism-t4-templating.min.js": 79230,
	"./prism-t4-vb.js": 99717,
	"./prism-t4-vb.min.js": 16879,
	"./prism-tap.js": 50803,
	"./prism-tap.min.js": 65037,
	"./prism-tcl.js": 13645,
	"./prism-tcl.min.js": 6071,
	"./prism-textile.js": 64379,
	"./prism-textile.min.js": 32309,
	"./prism-toml.js": 70132,
	"./prism-toml.min.js": 11526,
	"./prism-tremor.js": 99009,
	"./prism-tremor.min.js": 33411,
	"./prism-tsx.js": 82769,
	"./prism-tsx.min.js": 54547,
	"./prism-tt2.js": 18872,
	"./prism-tt2.min.js": 18738,
	"./prism-turtle.js": 9434,
	"./prism-turtle.min.js": 40340,
	"./prism-twig.js": 1369,
	"./prism-twig.min.js": 50523,
	"./prism-typescript.js": 59587,
	"./prism-typescript.min.js": 28125,
	"./prism-typoscript.js": 38689,
	"./prism-typoscript.min.js": 20227,
	"./prism-unrealscript.js": 36472,
	"./prism-unrealscript.min.js": 54450,
	"./prism-uorazor.js": 59574,
	"./prism-uorazor.min.js": 20392,
	"./prism-uri.js": 34248,
	"./prism-uri.min.js": 94402,
	"./prism-v.js": 44036,
	"./prism-v.min.js": 41206,
	"./prism-vala.js": 76410,
	"./prism-vala.min.js": 6868,
	"./prism-vbnet.js": 47501,
	"./prism-vbnet.min.js": 89271,
	"./prism-velocity.js": 38587,
	"./prism-velocity.min.js": 74613,
	"./prism-verilog.js": 71260,
	"./prism-verilog.min.js": 8238,
	"./prism-vhdl.js": 17822,
	"./prism-vhdl.min.js": 10608,
	"./prism-vim.js": 80046,
	"./prism-vim.min.js": 57088,
	"./prism-visual-basic.js": 88835,
	"./prism-visual-basic.min.js": 51837,
	"./prism-warpscript.js": 43037,
	"./prism-warpscript.min.js": 13703,
	"./prism-wasm.js": 28176,
	"./prism-wasm.min.js": 12522,
	"./prism-web-idl.js": 9274,
	"./prism-web-idl.min.js": 68308,
	"./prism-wgsl.js": 66473,
	"./prism-wgsl.min.js": 24939,
	"./prism-wiki.js": 18524,
	"./prism-wiki.min.js": 58094,
	"./prism-wolfram.js": 65882,
	"./prism-wolfram.min.js": 4756,
	"./prism-wren.js": 85794,
	"./prism-wren.min.js": 85404,
	"./prism-xeora.js": 52639,
	"./prism-xeora.min.js": 85569,
	"./prism-xml-doc.js": 83960,
	"./prism-xml-doc.min.js": 58226,
	"./prism-xojo.js": 62742,
	"./prism-xojo.min.js": 91592,
	"./prism-xquery.js": 76108,
	"./prism-xquery.min.js": 47902,
	"./prism-yaml.js": 60083,
	"./prism-yaml.min.js": 8653,
	"./prism-yang.js": 18981,
	"./prism-yang.min.js": 76687,
	"./prism-zig.js": 15168,
	"./prism-zig.min.js": 24410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61819;